<template>
  <div class="scheme">
    <object
      id="svg-object"
      ref="svgObject"
      type="image/svg+xml"
      :data="svgPath"
    >
    </object>
    <v-progress-circular
      v-if="loading"
      :width="3"
      color="rgba(0, 0, 0, 0.3)"
      indeterminate
      class="scheme_loader"
    ></v-progress-circular>
  </div>
</template>

<script>
const cssClassControlActivity = "st0";
const cssClassPrimaryColor = "st2";

export default {
  name: "Scheme",
  props: {
    step: {
      type: Object,
      default: () => ({})
    },
    stepIndex: {
      type: Number,
      default: 0
    },
    activeColor: {
      type: String,
      default: ""
    },
    additionalGroup: {
      type: [String, null, undefined],
      default: null
    },
    svgPath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      svgGroups: {},
      loading: false
    };
  },
  methods: {
    initSvg(object) {
      this.loading = false;
      if (!(object instanceof HTMLObjectElement))
        throw new TypeError("object must be a HTMLObjectElement");
      const svgDoc = object.contentDocument;
      const svgItem = svgDoc.querySelector("svg");
      if (!svgItem) return;
      this.svgGroups = Array.from(
        svgItem.querySelectorAll(`g.${cssClassControlActivity}`)
      ).reduce((acc, el) => ({ ...acc, [el.id]: el }), {});

      svgDoc.styleSheets[0].insertRule(
        `.${cssClassPrimaryColor} { fill: ${this._activeColor} !important; }`
      );

      this.fillSvg([this.step.svgGroup]);
    },
    clearSvg() {
      Object.keys(this.svgGroups).forEach(k => {
        this.svgGroups[k].classList.add(cssClassControlActivity);
      });
    },
    fillSvg(groups) {
      groups.forEach(g => {
        if (this.svgGroups[g])
          this.svgGroups[g].classList.remove(cssClassControlActivity);
      });
    }
  },
  watch: {
    stepIndex() {
      this.clearSvg();
      this.fillSvg([this.step.svgGroup]);
    },
    additionalGroup(val) {
      this.clearSvg();
      this.fillSvg([this.step.svgGroup, val]);
    },
    svgPath() {
      this.loading = true;
    }
  },
  computed: {
    _activeColor() {
      return this.activeColor || this.siteColors.primary;
    }
  },
  mounted() {
    this.loading = true;
    const object = this.$refs.svgObject;
    object.addEventListener("load", () => this.initSvg(object));
  }
};
</script>

<style lang="scss">
@import "Scheme";
</style>
